<template>
    <div>
        <div class="ph-item" v-if="searchIsLoading">
            <div class="ph-col-12">
                <div class="ph-picture"></div>
                <div class="ph-row">
                    <div class="ph-col-12 empty"></div>
                    <div class="ph-col-4 big"></div>
                    <div class="ph-col-2 big empty"></div>
                    <div class="ph-col-2 big"></div>
                    <div class="ph-col-2 big empty"></div>
                    <div class="ph-col-2 big"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                </div>
            </div>
        </div>

        <localization-provider :language="languageId + 's'">
            <intl-provider :locale="languageId + 's'">
                <grid v-if="productsData && listColumns"
                      :columns="listColumns"
                      :data-items="productsData"
                      :sort="sort"
                      :pageable="pageable"
                      :sortable="sortable"
                      :scrollable="none"
                      :skip="skip"
                      :take="take"
                      :total="total"
                      @pagechange="onPageChanged"
                      @sortchange="onSortChanged">

                    <template v-slot:designation="{ props }">
                        <td>
                            <a class="uk-text-primary uk-text-medium uk-text-bold" :href="props.dataItem.url">
                                <div class="uk-grid-small" uk-grid>
                                    <div class="uk-width-auto">
                                        <img :src="'/images/50/50/' + props.dataItem.imagePath" />
                                    </div>
                                    <div class="uk-width-expand">
                                        {{ props.dataItem[props.field] }}
                                    </div>
                                </div>
                            </a>
                        </td>
                    </template>

                    <template v-slot:sellingPrice="{ props }">
                        <td>
                            <span class="uk-text-medium uk-text-bold">{{ props.dataItem[props.field].toCurrencyString(languageId) }}</span>
                        </td>
                    </template>

                    <template v-slot:addToCart="{ props }">
                        <td>
                            <a class="productslist-addtocart-btn uk-text-primary uk-text-uppercase" href="#" :data-productid="props.dataItem.productId">
                                <img width="25" style="margin-top:-5px" height="" alt="" uk-img="data-src:/icone/ico_carrello.svg" uk-svg> {{ resources['AddProductShort'] }}
                            </a>
                        </td>
                    </template>
                </grid>
            </intl-provider>
        </localization-provider>
    </div>
</template>

<script lang="ts" src="./MyAccountProductsList.vue.ts"></script>
